import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useEffect, useState } from 'react';
import '~/apps/App.css';
import '~/apps/common.css';
import {useMenu} from 'react-instantsearch';
import {useLocation} from "react-router-dom";
import queryStrReader from "~/helpers/queryStrReader.js";

function MenuSelect({attribute, seeAllTitle, limit, filter}) {
    const location = useLocation();
    const {items, refine} = useMenu({attribute, limit});
    const [currentRefinement, setCurrentRefinement] = useState('');

    const handleUpdateRefinement = e => {
        e.stopPropagation();
        refine(e.currentTarget.value);
        setCurrentRefinement(e.currentTarget.value);
    };

    useEffect(() => {
        if (location.search) {
            const searchState = queryStrReader(location.search);
            if (searchState.menu && searchState.menu[attribute]) {
                setCurrentRefinement(searchState.menu[attribute]);
            } else {
                setCurrentRefinement('');
            }
        } else {
            setCurrentRefinement('');
        }
    }, [location.search])

    const sortedItem = items.sort((a, b) => (a.label > b.label) ? 1 : -1);

    let addClass = "";

    if (seeAllTitle === "Title") {
        addClass = "title";
    }
    if (seeAllTitle === "Departments") {
        addClass = "dept";
    }

    return <FormControl sx={{ m: 1, minWidth: 120 }} className={addClass}>
        <Select
            native
            inputProps={{
                name: attribute,
                id: attribute,
            }}
            className="ds-select"
            value={currentRefinement}
            onChange={handleUpdateRefinement}
            variant="outlined"
        >
            <option value="">{seeAllTitle + (filter ? " (" + items.length + ")" : "")} </option>
            {sortedItem.map(item => (
                <option
                    key={item.label}
                    value={item.isRefined ? currentRefinement : item.value}
                >
                    {item.label}
                </option>
            ))}
        </Select>
    </FormControl>;
}

export default MenuSelect;